package com.arena_web.ui.components.widgets

import androidx.compose.runtime.*
import com.arena_web.ui.theme.AppIcons
import com.arena_web.ui.utils.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.Img
import org.jetbrains.compose.web.dom.Video

@Composable
fun MediaLightbox(
    url: String,
    isVideo: Boolean,
    onDismiss: () -> Unit
) {
    var mediaIsSmall by remember { mutableStateOf(false) }
    var lightboxVisible by remember { mutableStateOf(false) }
    // First open downloads the full-size media from the CDN — show a spinner
    // until the image `load` / video `loadedmetadata` event fires, so a slow
    // network reads as loading rather than a dead overlay.
    var mediaLoaded by remember { mutableStateOf(false) }
    LaunchedEffect(Unit) { lightboxVisible = true }

    // Backdrop
    Box(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(Color.rgba(0, 0, 0, 200))
            .styleModifier {
                property("position", "fixed")
                property("top", "0")
                property("left", "0")
                property("z-index", "9999")
                property("opacity", if (lightboxVisible) "1" else "0")
                property("transition", "opacity 200ms ease")
            }
            .onClick { onDismiss() },
        contentAlignment = Alignment.Center
    ) {
        if (!mediaLoaded) {
            LoadingSpinner(size = 56.px)
        }
        Box(
            modifier = Modifier
                .styleModifier {
                    property("position", "relative")
                    property("transform", if (lightboxVisible) "scale(1)" else "scale(0.92)")
                    property("opacity", if (lightboxVisible) "1" else "0")
                    property("transition", "transform 250ms ease, opacity 250ms ease")
                }
                .onClick { it.stopPropagation() }
        ) {
            // Media content
            if (isVideo) {
                Video(
                    attrs = {
                        attr("src", url)
                        attr("controls", "")
                        attr("autoplay", "")
                        style {
                            property("max-width", "85vw")
                            property("max-height", "85vh")
                            property("border-radius", s(8))
                            property("display", "block")
                        }
                        ref { element ->
                            element.addEventListener("loadedmetadata", {
                                mediaIsSmall = element.clientWidth < 150 && element.clientHeight < 150
                                mediaLoaded = true
                            })
                            onDispose {}
                        }
                    }
                )
            } else {
                Img(
                    src = url,
                    attrs = {
                        style {
                            property("max-width", "85vw")
                            property("max-height", "85vh")
                            property("object-fit", "contain")
                            property("border-radius", s(8))
                            property("display", "block")
                        }
                        ref { element ->
                            element.addEventListener("load", {
                                mediaIsSmall = element.clientWidth < 150 && element.clientHeight < 150
                                mediaLoaded = true
                            })
                            onDispose {}
                        }
                    }
                )
            }

            // Close button
            Box(
                modifier = Modifier
                    .sSize(36)
                    .sBorderRadius(18)
                    .backgroundColor(Color.rgba(255, 255, 255, 40))
                    .cursor(Cursor.Pointer)
                    .styleModifier {
                        property("position", "absolute")
                        if (mediaIsSmall) {
                            property("top", "0")
                            property("right", s(-44))
                        } else {
                            property("top", s(8))
                            property("right", s(8))
                        }
                    }
                    .onClick {
                        it.stopPropagation()
                        onDismiss()
                    },
                contentAlignment = Alignment.Center
            ) {
                Image(
                    src = AppIcons.Close,
                    modifier = Modifier.sSize(18).styleModifier {
                        property("filter", "brightness(3)")
                    }
                )
            }
        }
    }
}
